import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import PaymentMethods from '../views/PaymentMethods.vue';
import TerminosDeUso from '../views/TerminosDeUso.vue';
import PoliticaPrivacidad from '../views/PoliticaPrivacidad.vue';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
    },
    {
        path: '/metodos-de-pago',
        name: 'PaymentMethods',
        component: PaymentMethods,
    },
    {
        path: '/terminos-de-uso',
        name: 'TerminosDeUso',
        component: TerminosDeUso,
    },
    {
        path: '/politica-privacidad',
        name: 'PoliticaPrivacidad',
        component: PoliticaPrivacidad,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
